import React from "react";
import blank1 from "../images/blank1.jpg";
import { Link } from "react-router-dom";
import OwlCarousel from "react-owl-carousel";
import Ajax, { domain } from "../ajax/Ajax";
import Upload from "./Upload";

class StockManagement extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDeletePrompt: false,
      name: "",
      unitPrice: "",
      promoPrice: "",
      costPrice: "",
      stock: "",
      description: "",
      images: [],
      salesUnit: "",
      showImages: false,
      productId: "",
      shippingFee: "",
      freeShippingRange: "",
      stockCreationSuccessful: false,
      stockCreationError: false,
      submitting: false,
      lastSavedProduct: "",
      hideImageEdit: true,
      imageUnmounted: false,
    };

    this.owlcarousel = React.createRef();
    this.closeManagementBtn = React.createRef();

    this.saveProduct = this.saveProduct.bind(this);
    this.addImageToGallery = this.addImageToGallery.bind(this);
    this.closeManagement = this.closeManagement.bind(this);
  }

  showImageGallery = () => {
    this.setState({ showImages: true });
  };

  removeImage = (image) => {
    console.log("removing", image);
    let images = this.state.images;
    let newImages = [];
    images.forEach((element) => {
      if (!(element.id === image.id)) {
        console.log("match");
        newImages.push(element);
      }
    });

    console.log(newImages);

    this.setState({
      images: newImages,
    });

    if (!image.temp) {
      // Delete image save on backend as well
    }
  };

  addImageToGallery(data) {
    console.log(data, "adding to gallery");
    let images = this.state.images;
    images.push(data);
    this.setState({
      images: images,
    });
  }

  closeManagement() {
    this.closeManagementBtn.current.click();
  }

  async saveProduct(event) {
    event.preventDefault();
    let closeManagement = this.closeManagement;

    let data = {
      focus: this.props.focus,
      focus_id: this.props.focusObj.token,
      product: {
        name: this.state.name,
        unit_price: this.state.unitPrice,
        promo_price: this.state.promoPrice,
        cost_price: this.state.costPrice,
        stock: this.state.stock,
        product_id: this.state.productId,
        images: this.state.images,
        description: this.state.description,
        sales_unit: this.state.salesUnit,
        shipping_fee: this.state.shippingFee,
        free_shipping_range: this.state.freeShippingRange,
      },
    };

    this.setState({
      submitting: true,
    });
    let response = null;
    if (this.state.editing) {
      data.patch_mode = "edit";
      response = await Ajax.patchData(domain + "/en/api/shop/v1/stock/", data);
    } else {
      response = await Ajax.postData(domain + "/en/api/shop/v1/stock/", data);
    }

    console.log(response);
    if (response) {
      if (response.status === 200) {
        let savedProduct = this.state.name;
        this.setState({
          stockCreationSuccessful: true,
          submitting: false,
          lastSavedProduct: savedProduct,
          name: "",
          unitPrice: "",
          promoPrice: "",
          costPrice: "",
          stock: "",
          description: "",
          images: [],
          salesUnit: "",
          showImages: false,
          productId: "",
          shippingFee: "",
          freeShippingRange: "",
          editing: false,
        });

        setTimeout(function () {
          closeManagement();
        }, 1000);
      }
    }
  }

  componentDidMount() {
    console.log(this.props);
    if (this.props.product) {
      let product = this.props.product;
      if (!product.promo_price) {
        var promoPrice = "";
      }

      if (!product.shipping_fee) {
        var shippingFee = "";
      }

      if (!product.free_shipping_range) {
        var freeShippingRange = "";
      }
      let gallery = [];
      if (product.item.gallery) {
        gallery = product.item.gallery;
      }
      this.setState({
        name: product.item.name,
        unitPrice: product.item.price,
        promoPrice: promoPrice,
        description: product.item.description,
        stock: product.item.stock,
        productId: product.item.id,
        images: gallery,
        shippingFee: shippingFee,
        freeShippingRange: freeShippingRange,
        editing: true,
      });
    }
  }

  render() {
    let submitting = "";
    if (this.state.submitting) {
      submitting = "is-loading";
    }

    return (
      <div className="card is-shadowless bordered-card animated fadeIn">
        <div className="card-header d-flex justify-content-between">
          <div className="card-header-title">Manage Stock</div>

          <div className="m-2 d-flex justify-content-between">
            <div className="mr-4">
              <button className="button is-info is-small">
                <span className="zmdi zmdi-plus"></span>
              </button>
            </div>

            <div className="mr-1">
              <button className="button is-danger is-small">
                <span className="zmdi zmdi-delete"></span>
              </button>
            </div>
            <div className="m-1">
              <Link to="/myshop/home/">
                <button
                  ref={this.closeManagementBtn}
                  aria-label="delete"
                  className="delete"
                ></button>
              </Link>
            </div>
          </div>
        </div>

        <div className="card-content">
          {this.state.showDeletePrompt ? (
            <div className="message is-danger delete-prompt animated slideInDown">
              <div className="message-body">
                <div className="has-text-centered">
                  <span className="zmdi zmdi-close-circle mr-2"></span>Are you
                  sure you want to delete this item? This will equally delete
                  every data associated with the item.
                </div>
                <br />
                <div className="d-flex justify-content-between">
                  <button className="button is-primary">Cancel</button>
                  <button className="button is-danger">Delete</button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}

          <form action="#" onSubmit={this.saveProduct}>
            {this.state.stockCreationSuccessful ? (
              <div className="mb-2 animated fadeIn">
                <div className="message is-success">
                  <div className="message-body has-text-centered has-text-success">
                    <span className="zmdi zmdi-check-circle mr-2"></span>
                    <span className="has-text-info">
                      {this.state.lastSavedProduct}{" "}
                    </span>
                    <span className="">saved successfully!</span>
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}

            {this.state.stockCreationError ? (
              <div className="mb-2 animated fadeIn">
                <div className="message is-danger">
                  <div className="message-body has-text-centered has-text-danger">
                    <span className="zmdi zmdi-close-circle mr-2"></span>
                    <span>An error occurred. Please try again</span>
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}

            <div className="field">
              <label className="label">Product Name</label>
              <div className="control">
                <input
                  value={this.state.name}
                  onChange={(event) => {
                    this.setState({ name: event.target.value });
                  }}
                  required
                  className="input"
                  type="text"
                  placeholder="name of product"
                />
                <input
                  name="product_id"
                  type="hidden"
                  value={this.state.productId}
                />
              </div>
            </div>

            <div className="field d-flex justify-content-center">
              {this.state.showImages ? (
                <div>
                  <button
                    type="button"
                    onClick={() => {
                      this.setState({
                        showImages: false,
                      });
                    }}
                    className="button"
                  >
                    <span className="zmdi zmdi-image mr-2"></span>
                    <span className="fas fa-angle-up"></span>
                  </button>
                </div>
              ) : (
                <div>
                  <button
                    type="button"
                    onClick={() => {
                      this.setState({
                        showImages: true,
                      });
                    }}
                    className="button"
                  >
                    <span className="zmdi zmdi-image mr-2"></span>
                    <span className="fas fa-angle-down"></span>
                  </button>
                </div>
              )}
            </div>

            {this.state.showImages ? (
              <div className="field animated fadeIn">
                <div className="columns">
                  <div className="column is-11">
                    {this.state.images.length > 0 ? (
                      <OwlCarousel
                        ref={this.owlcarousel}
                        className="owl-theme"
                        loop
                        items={1}
                        margin={10}
                      >
                        {this.state.images.map((image) => (
                          <div key={image.id + "-product-image"}>
                            <figure title="" className="image">
                              <img src={domain + image.url} alt="" />

                              <div className="mt-2 d-flex justify-content-center">
                                <button
                                  onClick={() => {
                                    this.removeImage(image);
                                  }}
                                  title="Remove image"
                                  className="button is-round is-danger"
                                >
                                  <span className="zmdi zmdi-delete"></span>
                                </button>
                              </div>
                            </figure>
                          </div>
                        ))}
                      </OwlCarousel>
                    ) : (
                      <div>
                        <figure
                          onMouseOver={() => {
                            this.setState({
                              hideImageEdit: false,
                            });
                          }}
                          onMouseLeave={() => {
                            this.setState({
                              hideImageEdit: true,
                            });
                          }}
                          className="image"
                        >
                          <img src={blank1} alt="" />
                        </figure>
                      </div>
                    )}
                  </div>

                  <div className="column is-1 d-flex align-items-center justify-content-center">
                    <div>
                      <div>
                        <Upload addImageToGallery={this.addImageToGallery} />
                      </div>
                      {this.state.images.length > 1 ? (
                        <div className="mt-4">
                          <button
                            type="button"
                            title="Forward"
                            onClick={() => {
                              this.owlcarousel.current.next();
                            }}
                            className="button is-light is-round"
                          >
                            <span className="fas fa-angle-right"></span>
                          </button>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div></div>
            )}

            <div className="field">
              <label className="label">Unit Price</label>
              <div className="control">
                <input
                  value={this.state.unitPrice}
                  onChange={(event) => {
                    this.setState({ unitPrice: event.target.value });
                  }}
                  required
                  name="unit_price"
                  className="input"
                  type="number"
                  placeholder="unit price"
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Promo Price</label>
              <div className="control">
                <input
                  value={this.state.promoPrice}
                  onChange={(event) => {
                    this.setState({ promoPrice: event.target.value });
                  }}
                  className="input"
                  name="promo_price"
                  type="number"
                  placeholder="only define this during promotion"
                />
              </div>
            </div>

            <div className="field">
              <div className="columns">
                <div className="column">
                  <label className="label">Shipping Fee</label>
                  <div className="control">
                    <input
                      name="cost_price"
                      value={this.state.shippingFee}
                      onChange={(event) => {
                        this.setState({ shippingFee: event.target.value });
                      }}
                      className="input"
                      type="number"
                      placeholder="shipping fee"
                    />
                  </div>
                </div>

                <div className="column">
                  <label className="label">Free Shipping Range</label>
                  <div className="control">
                    <input
                      name="cost_price"
                      value={this.state.freeShippingRange}
                      onChange={(event) => {
                        this.setState({
                          freeShippingRange: event.target.value,
                        });
                      }}
                      className="input"
                      type="number"
                      placeholder="free range"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="field">
              <label className="label">Cost Price</label>
              <div className="control">
                <input
                  name="cost_price"
                  value={this.state.costPrice}
                  onChange={(event) => {
                    this.setState({ costPrice: event.target.value });
                  }}
                  className="input"
                  type="number"
                  placeholder="cost price"
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Stock</label>
              <div className="control">
                <input
                  value={this.state.stock}
                  onChange={(event) => {
                    this.setState({ stock: event.target.value });
                  }}
                  name="stock"
                  className="input"
                  type="number"
                  placeholder="current stock"
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Unit of Sale</label>
              <div className="control">
                <input
                  value={this.state.salesUnit}
                  onChange={(event) => {
                    this.setState({ salesUnit: event.target.value });
                  }}
                  className="input"
                  name="sales_unit"
                  type="text"
                  placeholder="unit of sale"
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Description</label>
              <div className="control">
                <textarea
                  name="description"
                  value={this.state.description}
                  onChange={(event) => {
                    this.setState({ description: event.target.value });
                  }}
                  rows={3}
                  className="textarea"
                  placeholder="describe this product"
                ></textarea>
              </div>
            </div>

            <div className="field">
              <button
                className={"button is-primary is-fullwidth " + submitting}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default StockManagement;
